import script from "./DyTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DyTable.vue?vue&type=script&setup=true&lang=js"

import "./DyTable.vue?vue&type=style&index=0&id=bd581a10&lang=css"

const __exports__ = script;

export default __exports__